"use client";

import Image from "next/image";

/**
 * Reusable Meet the Team Section
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {string} props.description - Section subtitle
 * @param {Array} props.members - Array of member objects { name, role, image }
 */
export const AppTeamSection = ({
  id = "team",
  title = "Meet the team",
  description = "",
  members = [],
}) => {
  return (
    <section
      id={id}
      className="pt-16 pb-16 relative z-10 overflow-hidden bg-[#1e1e1e]"
    >
      <div className="mx-auto px-6 md:px-16 lg:px-32 relative z-10 max-w-[1440px]">
        {/* Section Title */}
        <div className="flex flex-col items-center max-w-[1280px] mx-auto mb-16">
          <h2
            className="text-3xl md:text-[48px] font-normal text-[#f8f7f4] text-center tracking-[-0.96px] w-full"
            style={{ lineHeight: "56px" }}
          >
            {title}
          </h2>
          {description && (
            <p className="mt-4 max-w-[640px] text-base font-normal text-[#c4c4c4] text-center tracking-[-0.032px] leading-6">
              {description}
            </p>
          )}
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-14 max-w-[880px] mx-auto">
          {members.map((member, index) => (
            <div
              key={index}
              className="group flex flex-col items-center text-center"
            >
              {/* Avatar */}
              <div className="relative w-[140px] h-[140px] md:w-[160px] md:h-[160px] rounded-full overflow-hidden bg-[#2e2e2e] ring-1 ring-[#2e2e2e] transition-all duration-500 group-hover:ring-[#8c67ec]/50 group-hover:-translate-y-1">
                {member.image && (
                  <Image
                    src={member.image}
                    alt={member.name}
                    fill
                    sizes="160px"
                    style={{ objectPosition: member.imagePosition || "center" }}
                    className="object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                )}
              </div>

              {/* Name & Role */}
              <p className="mt-6 text-base font-semibold text-[#f8f7f4] tracking-[-0.032px] leading-6">
                {member.name}
              </p>
              <p className="mt-1 text-sm font-normal text-[#8f8f8f] leading-5">
                {member.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
